import React from 'react';
import HomePageCardSkeleton from '../Skeletons/HomePage/HomePageCardSkeleton';
import config from 'config/config';

interface VendorEventsListingSkeletonProps {
  numberOfCards?: number;
}

const VendorEventsListingSkeleton: React.FC<
  VendorEventsListingSkeletonProps
> = ({ numberOfCards = config.homePageEvents.numberOfEventsDisplayed }) => {
  return (
    <div className="grid gap-[24px] grid-cols-1 min-[700px]:grid-cols-2 min-[1024px]:grid-cols-3 min-[1380px]:grid-cols-4">
      {new Array(numberOfCards)
        .fill(undefined)
        .map((_, index) => index + 1)
        .map(id => (
          <HomePageCardSkeleton key={id} />
        ))}
    </div>
  );
};

export default VendorEventsListingSkeleton;
